import React from 'react';

import { Box, Typography, Avatar } from '@mui/material';

import UserStarIcon from '../assets/images/stars-user.webp';

const CandidateExperience = ({ experiences }) => {
  return (
    <Box
      border="1px solid #E0E0E0"
      borderRadius="8px"
      bgcolor="white"
      overflow='auto'
      display='flex'
    >
      {experiences.map((experience, index) => (
        <Box flex={1} key={index} display="inline-flex" px={2} py={5} alignItems="center" mx={2}>
          <Typography color="#BDBDBD" display={index === 0 ? "none" : "initial"} noWrap>
            ------------------------
          </Typography>

          {index === 0 && (
            <Avatar
              sx={{
                bgcolor: 'transparent',
                color: '#FFC107',
                width: 40,
                height: 40,
              }}
            >
              <Box component='img' src={UserStarIcon} width='100%' height='100%' />
            </Avatar>
          )}

          {/* Experience Details */}
          <Box ml={2}>
            {index === 0 &&
              <Typography variant="body1" noWrap fontFamily='Outfit' fontWeight={index === 0 ? 'bold' : 'normal'}>
                Professional Experience
              </Typography>}
            <Typography variant="body1" noWrap fontFamily='Outfit' fontWeight={'500'}>
              {experience}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default CandidateExperience;
